import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { store, persistor, history } from "./reducers/store";
import { PersistGate } from "redux-persist/integration/react";
import * as serviceWorker from "./registerServiceWorker";
import App from "./App";

declare global {
  interface Window {
    server: any;
  }
}

const rootEl = document.getElementById("root");
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  rootEl
);

// disabled PWA service workers to remove caching issues
serviceWorker.unregister();
